<div matTooltip='{{ "General.ActivateAccount" | translate }}' [matTooltipDisabled]="!disabled">
  <button mat-flat-button class=" small" color="primary" (click)="onAddNewButtonClicked()" [disabled]="disabled">
    <app-icon name="add-circle" class="mr-2" size="xs"></app-icon>
    {{ label }}
    <ng-content></ng-content>
  </button>
</div>
